import axios from 'axios';
import { baseUrl, ServiceType } from '../../contstant/apiEndpoints';

export const createApiInstance = (serviceType: ServiceType) => {
  const instance = axios.create({
    baseURL: baseUrl(serviceType),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    timeout: 10000,
    withCredentials: true, // Include cookies in requests
    paramsSerializer: {
      indexes: null, // use repeat format: key=val1&key=val2
    },
  });

  // Basic response interceptor
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        return Promise.reject(error.response);
      } else if (error.request) {
        return Promise.reject(error.request);
      } else {
        return Promise.reject(error);
      }
    },
  );
  return instance;
};
